import React, { FC, ReactNode } from 'react';

import getClassName from 'src/common/utils/getClassName';

import s from './EventDetailsHeader.module.scss';

type Props = {
  children?: ReactNode;
  classNameModifier?: string;
  title?: string;
  description?: ReactNode;
};

const EventDetailsHeader:FC<Props> = ({
  children,
  classNameModifier = '',
  title,
  description,
}) => (
  <div className={getClassName(s, 'root', classNameModifier)}>
    {children}
    <h3 className={s.title}>
      {title}
    </h3>
    <p className={s.description}>
      {description}
    </p>
  </div>
);

export default EventDetailsHeader;
